import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KakobuySpreadsheetGuide from "@/pages/article/kakobuy-spreadsheet-guide/page";
import KakobuySpreadsheetSneakers from "@/pages/article/kakobuy-spreadsheet-sneakers/page";
import CSSBuySpreadsheetGuide from "@/pages/article/cssbuy-spreadsheet-guide/page";
import SuperbuySpreadsheetGuide from "@/pages/article/superbuy-spreadsheet-guide/page";
import OopbuySpreadsheetGuide from "@/pages/article/oopbuy-spreadsheet-guide/page";
import KakobuyVsCSSBuy from "@/pages/article/kakobuy-vs-cssbuy/page";
import KakobuyVsSuperbuy from "@/pages/article/kakobuy-vs-superbuy/page";
import KakobuyVsOopbuy from "@/pages/article/kakobuy-vs-oopbuy/page";
import KakobuyFindsDatabase from "@/pages/article/kakobuy-finds-database/page";
import KakobuySafetyGuide from "@/pages/article/kakobuy-safety-guide/page";
import KakobuySpreadsheetFashion from "@/pages/article/kakobuy-spreadsheet-fashion/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/kakobuy-spreadsheet-sneakers",
    element: <KakobuySpreadsheetSneakers />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <CSSBuySpreadsheetGuide />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/oopbuy-spreadsheet-guide",
    element: <OopbuySpreadsheetGuide />,
  },
  {
    path: "/kakobuy-vs-cssbuy",
    element: <KakobuyVsCSSBuy />,
  },
  {
    path: "/kakobuy-vs-superbuy",
    element: <KakobuyVsSuperbuy />,
  },
  {
    path: "/kakobuy-vs-oopbuy",
    element: <KakobuyVsOopbuy />,
  },
  {
    path: "/kakobuy-finds-database",
    element: <KakobuyFindsDatabase />,
  },
  {
    path: "/kakobuy-safety-guide",
    element: <KakobuySafetyGuide />,
  },
  {
    path: "/kakobuy-spreadsheet-fashion",
    element: <KakobuySpreadsheetFashion />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;